/*
 *  I04CONSCHAUFANI18n.js
 *
 *  Created by Sébastien Hecart on 2018-10-27 15:39:05 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I04CONSCHAUFAN_SECTION_0_TITLE: 'Consommation chauffage par mois',
  I04CONSCHAUFAN_I04DIMPUISSCHAUD: 'Calcul Déperdition selon la surface habitable',
  I04CONSCHAUFAN_I04DIMPUISCONS: 'Calcul Déperdition Selon bilan de consommation',
  I04CONSCHAUFAN_in_deperdition: 'Déperdition',
  I04CONSCHAUFAN_dju_uuid: 'DJU',
  I04CONSCHAUFAN_in_tempExtBase: 'Température de base ext',
  I04CONSCHAUFAN_in_temperatureAmbiante: 'Consigne ambiance',
  I04CONSCHAUFAN_in_nbJourChauffe: 'Nombre jours de chauffe',
  I04CONSCHAUFAN_in_nombreHeureReduit: "Nombre d'heures réduit",
  I04CONSCHAUFAN_in_nombreDegreAbaisse: 'Nombre degrés abaissés',
  I04CONSCHAUFAN_SECTION_1_TITLE: 'Résultat',
  I04CONSCHAUFAN_res_intermittence: 'Intermitence',
  I04CONSCHAUFAN_res_consoAnnuelle: 'Consommation annuelle'
}
